import Vue from 'vue'
import { getAction, postAction } from './http'//引入封装的get post方法

const tableDataHttp = (params)=>getAction("/api/official/website/productTables/special_table",params);
export {
    tableDataHttp,
}